import React from 'react';

import {
  Checkbox as ChakraCheckbox,
  forwardRef,
  useStyleConfig,
} from '@chakra-ui/react';

import { CheckboxProps } from './types/checkbox-props';

export const Checkbox = forwardRef<CheckboxProps, 'input'>((props, ref) => {
  const styles = useStyleConfig('Checkbox', { ...props });
  return <ChakraCheckbox ref={ref} sx={styles} {...props} />;
});
